module.exports = __webpack_public_path__ + "static/ha3-237d137e0ca3d4ef245919da66262ef7.jpg";